export default __webpack_public_path__ + "static/media/gridIcon.dac5ce58.svg";